import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import ga from 'src/utils/pixels/gtag'

type IHelpful = 'helpful' | 'not-helpful'
type IArticleSurface = 'help' | 'blog'

type IProps = {
  title: string
  slug: string
  topic: string
  surface: IArticleSurface
}

const LikedArticle = ({ title, slug, topic, surface }: IProps) => {
  const { t, i18n } = useTranslation('common')
  const [helpful, setHelpful] = useState<undefined | IHelpful>()

  const handleOnClick = (value: IHelpful) => () => {
    setHelpful(value)
    ga.event('article_helpful', {
      helpful: value,
      title,
      slug,
      topic,
      surface,
      locale: i18n.language
    })
  }

  return (
    <div className="border-t border-ink-100/15 pt-6">
      <div className="flex items-center justify-between gap-4">
        <p className="font-display text-[15px] font-medium text-ink-700 md:text-[17px]">
          {t('HELP.LIKED_QUESTION')}
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleOnClick('helpful')}
            disabled={!!helpful}
            className={`flex size-10 items-center justify-center rounded-full border transition-all ${
              helpful === 'not-helpful'
                ? 'border-ink-100/15 text-ink-200/40'
                : helpful === 'helpful'
                  ? 'border-blue-500 text-blue-500'
                  : 'border-ink-100/40 text-ink-200 hover:border-blue-500 hover:text-blue-500'
            }`}
            aria-label={t('HELP.ARTICLE_HELPFUL')}
          >
            <ThumbUpOffAltIcon className="text-xl" />
          </button>
          <button
            type="button"
            onClick={handleOnClick('not-helpful')}
            disabled={!!helpful}
            className={`flex size-10 items-center justify-center rounded-full border transition-all ${
              helpful === 'helpful'
                ? 'border-ink-100/15 text-ink-200/40'
                : helpful === 'not-helpful'
                  ? 'border-ink-700 text-ink-700'
                  : 'border-ink-100/40 text-ink-200 hover:border-ink-700 hover:text-ink-700'
            }`}
            aria-label={t('HELP.ARTICLE_NOT_HELPFUL')}
          >
            <ThumbDownOffAltIcon className="text-xl" />
          </button>
        </div>
      </div>
      {helpful && (
        <p className="mt-3 text-[13px] text-ink-200">
          {helpful === 'helpful' ? t('HELP.LIKED_YES') : t('HELP.LIKED_NO')}
        </p>
      )}
    </div>
  )
}

export default LikedArticle
